import WiresActivityPage from "components/pages/WiresActivityPage";

/**
 * @name CaptureWireActivityDefault
 * @returns {React.Component}
 * @description 
 */
export default function CaptureWireActivityDefault(props) {
    return <WiresActivityPage />;
}